module.exports = __webpack_public_path__ + "img/Support-skill-532.26b71adc.png";